import { SelectorIcon } from '@heroicons/react/outline'

export default function DragIcon() {
  return (
    <div className="inline-block text-gray-400 align-middle cursor-grab hover:text-indigo-500">
      <SelectorIcon className={`h-4 w-4`} aria-hidden="true" />
    </div>
  )
}
